<!-- <div class="dialoghead">
  <h1 class="mat-mdc-dialog-title">Share this Insight</h1>
  <mat-dialog-content>
    <p>
      Share this report with your network or save it for later.
    </p>
    
  </mat-dialog-content>
  <div class="modal-section">
      <div class="input-group">
        <input
          id="shareUrl"
          type="text"
          readonly
          [value]="'https://your-domain.com/reports/'+ prevData?.id "
          class="form-input"
        />
        
      </div>
    </div>
  <mat-dialog-actions>
    <button mat-button (click)="copyLink()">{{copyButtonText}}</button>
  </mat-dialog-actions>
  <ng-container *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>
</div>

<span mat-button mat-dialog-close class="close-btn-modal material-icons"
  >close</span
> -->

<div class="comming-sooon">
  <div class="comming-soon-img"></div>
  <div class="comming-soon-word">
    <p>COMING SOON</p>
  </div>
</div>
